import React, { useState, useEffect,  useContext } from "react";
import { AppContext } from "../../../../util/context";
import { Controller, Control, FieldErrors } from "react-hook-form";
import { IFieldDateOption } from "../InputFields.types";

import styles from "./DateOptions.module.scss";
import block from 'bem-css-modules';

import { sanitizeContent as s } from "../../../../util/functions";

type Item = {
  day: string, 
  selected: boolean
}

const DateOptions = (props: { fieldData: IFieldDateOption, errors: FieldErrors, control: Control }) => {
  const { settings: { locale } } = useContext(AppContext);
  const {
    fieldData: {
      excludeWeekends,
      startingDay,
      sequenceDaysLength,
      title,
      label,
      validationText,
      settings: [{
        crmProperty,
        required,
      }]
    },
    control,
    errors
  } = props;

  const b = block(styles);
  const [selectedDays, setSelectedDays] = useState<Array<Item>>([]);

  const createRangeArray = (start:number, end:number) => Array.from(Array(end - start + 1).keys()).map(x => x + start);

  const returnDays = () => {
    const daysArray: Array<Item> = [];

    const rangeArray = createRangeArray(startingDay, startingDay+sequenceDaysLength-1);

    const today = new Date();
    rangeArray.forEach((num:number) => {
      if (num !== 0) {
        today.setDate(today.getDate() + 1);
      }
      if(excludeWeekends && checkIfWeekendDay(today)){
        while (checkIfWeekendDay(today)) {
          today.setDate(today.getDate() + 1); // Keep incrementing until a working day is found
        }
      }

      daysArray.push({day: today.toLocaleDateString(locale, { weekday: 'long', year: "numeric", month: "short", day: "2-digit" }), selected: false});
    });

    return daysArray;
  }
  
  const checkIfWeekendDay = (date: Date) => {
    const day = date.getDay(); // Sunday: 0, Monday: 1, ..., Saturday: 6
    return day === 0 || day === 6;
  };

  useEffect(()=>{
    setSelectedDays(returnDays());
  },[]);

  const handleSelectDay = (item: Item) => {
    const index = selectedDays.indexOf(item);
    const newSelections = [...selectedDays];
    newSelections[index].selected = !newSelections[index].selected;
    setSelectedDays([...newSelections]);

    //returns string of concatenated selections as field_value
    let concatenated = "";
    newSelections.filter(item => item.selected === true).forEach(opt => {
      concatenated += `${opt.day} ~|~ `;
    });
    return concatenated.substring(0, concatenated.length-5);
  }

  return (
    <>
      {title && <h3>{title}</h3>}
      {selectedDays.map((item:Item) => {
        return <Controller key={item.day} 
          name={label}
          control={control}
          rules={{ required: required }}
          defaultValue={false}
          render={({ field: {
            onChange,
            value
          } }) => (
            <div className={`${b("button")} ${item.selected && b("status-checked")}`}>
              <label htmlFor={item.day}>
                <span className={`${b("checkbox")} ${item.selected && b("is-checked")}`}>
                  <input
                    id={item.day}
                    data-crm-field={crmProperty}
                    type="checkbox"
                    checked={value}
                    onChange={() => onChange(handleSelectDay(item))}
                  />
                </span>
                <span className={b("text")}>{item.day}</span>
              </label>
            </div>
          )} 
        />
      })}
      {errors[crmProperty] && (
        <div className={b("error")} dangerouslySetInnerHTML={{ __html: s(validationText) }} />
      )}
    </>
  )
}

export default DateOptions;